export function focusToField(name: string) {
  const inputToFocus = document.querySelector<HTMLInputElement>(
    `input[name=${name}]`
  );
  inputToFocus?.focus();
}
